type HashAlgorithm = 'SHA-256' | 'SHA-512';

export async function hash(
    input: string,
    hashAlgorithm: HashAlgorithm = 'SHA-256'
): Promise<string> {
    const encoder = new TextEncoder();
    const data = encoder.encode(input);
    const hashBuffer = await window.crypto.subtle.digest(hashAlgorithm, data);
    const hashArray = Array.from(new Uint8Array(hashBuffer));

    return hashArray.map((b) => b.toString(16).padStart(2, '0')).join('');
}

export async function hashEmail(email: string): Promise<string> {
    const normalizedEmail = email.trim().toLowerCase();

    if (normalizedEmail === '') {
        return '';
    }

    return hash(normalizedEmail);
}
